import { Injectable } from '@angular/core';
import { BaseService } from '@core/services/base.service';
import {
  Http,
  Headers,
  RequestMethod,
  ResponseContentType
} from "@angular/http";

import { ConfigService } from "@shared/utils/config.service";
import { Observable } from "rxjs/Rx";
import { ParametrizacaoObject } from '@modules/visitas/services/models';

@Injectable()
export class ParametrizacaoService extends BaseService{
  baseUrl: string = "";
  mockUrl = "http://localhost:3000"

  constructor(private http: Http, private configService: ConfigService) {
    super();
    this.baseUrl = configService.getApiURI();
  }

  authorizedHeaders(): Headers {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return headers;
  }

  saveMAPV(params): Observable<any> {
    // salvarAlerta(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        `${this.baseUrl}/parametrizacao/saveMAPV?yearMonthStart=${params.yearMonthStart}&yearMonthEnd=${params.yearMonthEnd}&openOrClose=${params.openOrClose}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);

    // return this.http
    //   .post(this.baseUrl + "/parametrizacao/saveMAPV", params, { headers })
    //   .map(response => "")
    //   .catch(this.handleError);
  }

  saveInvasao(params): Observable<any> {
    // salvarAlerta(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        `${this.baseUrl}/parametrizacao/saveInvasao?fzsInvasor=${params.invasor}&fzsVago=${params.vago}&qtdMeses=${params.qtd}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);

  }

  saveInvasaoPorCidade(params): Observable<any> {
    // salvarAlerta(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        `${this.baseUrl}/parametrizacao/saveInvasaoPorCidade?fzsInvasor=${params.invasor}&fzsVago=${params.vago}&qtdMeses=${params.qtd}&idsCidade=${params.ids}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);

  }

  removeInvasaoPorCidade(params): Observable<any> {
    // salvarAlerta(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        `${this.baseUrl}/parametrizacao/removeInvasaoPorCidade?fzsInvasor=${params.invasor}&fzsVago=${params.vago}&qtdMeses=${params.qtd}&idsCidade=${params.ids}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);

  }

  getValuesMAPV(): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    // .get(this.baseUrl + `/vendedores/RetornaIdSetorComercialPorCdfzs?cdfzs=${cdfzs}`, { headers })
    return this.http
      .get(this.baseUrl + `/parametrizacao/getValuesMAPV`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getCidades(fzsVago, fzsInvasor): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/parametrizacao/getCidades?fzsVago=${fzsVago}&fzsInvasor=${fzsInvasor}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  // getHistorico(fzs, cidadeSelecionada, ufSelecionada, dataSelecionada, mostrar5Dias): Observable<any[]> {
  //   let headers = new Headers();
  //   headers.append("Content-Type", "application/json");
  //   let authToken = localStorage.getItem("auth_token");
  //   headers.append("Authorization", `Bearer ${authToken}`);

  //   return this.http
  //     .get(`${this.baseUrl}/parametrizacao/getHistorico?fzs=${fzs}&ufSelecionada=${ufSelecionada}&cidadeSelecionada=${cidadeSelecionada}&dataSelecionada=${dataSelecionada}&mostrar5Dias=${mostrar5Dias}`, { headers })
  //     .map(response => response.json())
  //     .catch(this.handleError);
  // }

  
getHistorico(fzs, cidadeSelecionada, ufSelecionada, dataSelecionada, mostrar5Dias): Observable<any[]> {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  let authToken = localStorage.getItem("auth_token");
  headers.append("Authorization", `Bearer ${authToken}`);

  const url = `${this.baseUrl}/parametrizacao/getHistorico` +
    `?fzs=${encodeURIComponent(fzs || '')}` +
    `&ufSelecionada=${encodeURIComponent(ufSelecionada || '')}` +
    `&cidadeSelecionada=${encodeURIComponent(cidadeSelecionada || '')}` +
    `&dataSelecionada=${encodeURIComponent(dataSelecionada || '')}` +
    `&mostrar5Dias=${mostrar5Dias === true}`;

  console.log("URL da consulta:", url);

  return this.http
    .get(url, { headers })
    .map(response => response.json())
    .catch(this.handleError);
}


  buscarTodos(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/parametrizacao/buscarTodos`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }
  
  buscarTodosExp(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/parametrizacao/buscarTodosExp`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  buscarUfs(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/parametrizacao/buscarUfs`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  buscarCidades(uf): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/parametrizacao/buscarCidades?uf=${uf}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  renovarInvasao(itensSelecionados): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
  
    return this.http
      .post(`${this.baseUrl}/parametrizacao/renovarInvasao`, JSON.stringify(itensSelecionados), { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

}
